module.exports = __webpack_public_path__ + "static/love-f9704d0d5705c78bd711a34e89733ebd.png";